import React, { useEffect } from 'react';
import { ROUTES } from '@constants';
import styles from './PromoBanner.module.scss';
import classnames from 'classnames/bind';
import { Button } from '@components';
import { Typography } from 'gd-design-library';
import { useRouter } from 'next/router';
import { pushSelectPromotionEvent, pushViewPromotionEvent } from '@utils';

const cx = classnames.bind(styles);

const CN = 'promo-banner';
const infoClassName = `${CN}__info`;
const imageClassName = `${CN}__image`;
const titleClassName = `${CN}__title`;
const descriptionClassName = `${CN}__description`;
const buttonClassName = `${CN}__button`;
const buttonDesktopClassName = `${buttonClassName}--desktop`;
const buttonMobileClassName = `${buttonClassName}--mobile`;

interface PromoBannerProps {
    promoBackgroundDesktop: string;
    promoBackgroundMobile: string;
    promoTitle: string;
    promoDescription: string;
    isDiscountPromotion: boolean;
    discountID: string;
}

export const PromoBanner: React.FC<PromoBannerProps> = ({
  promoBackgroundDesktop,
  promoBackgroundMobile,
  promoTitle,
  promoDescription,
  isDiscountPromotion,
  discountID
}) => {
  const router = useRouter();

  const redirectToDiscount = (): void => {
    pushSelectPromotionEvent(promoTitle, discountID);
    router.push(`${ROUTES.discountedProducts}/${discountID}`);
  };

  useEffect(() => {
    pushViewPromotionEvent(promoTitle, discountID);
  }, [ promoTitle, discountID ]);

  return <div className={ cx(CN) }>
    <picture>
      <source srcSet={ promoBackgroundMobile } media='(max-width: 767px)' />
      <source srcSet={ promoBackgroundDesktop } />
      <img className={ cx(imageClassName) } src={ promoBackgroundDesktop }/>
    </picture>
    <div className={ cx(infoClassName) }>
      <Typography
        variant='h6'
        className={ cx(titleClassName) }
      >
        { promoTitle }
      </Typography>
      <Typography
        variant='h4'
        className={ cx(descriptionClassName) }
      >
        { promoDescription }
      </Typography>
      { isDiscountPromotion &&
        <Button
          className={ cx(buttonDesktopClassName) }
          onClick={ redirectToDiscount }
        >
          Discover
        </Button>
      }
    </div>
    { isDiscountPromotion &&
      <Button
        className={ cx(buttonMobileClassName) }
        onClick={ redirectToDiscount }
      >
        Discover
      </Button>
    }
  </div>;
};
